/**
 * Extracted from sections/ns-exercise-upgrades.liquid (inline <script> at line 276).
 * Config bridge: window.__nsExerciseUpgradesSliders, keyed by section id + container class.
 * This block sat inside a nested Liquid `for` (exercise x muscle type), so a
 * page rendering N combinations inlined this whole slider N times over, each
 * copy differing only in a container class and a function-name suffix built
 * from the loop indices. Worse, the suffix came from the INNER loop, so two
 * exercises produced two `productTeaserLayoutUpgrades1` declarations that overwrote each other
 * and only worked because each call followed its own definition. Each entry
 * now boots in its own closure, so the collision is gone and the code is
 * downloaded once and cached.
 */

(function () {
  var cfg = window.__nsExerciseUpgradesSliders = window.__nsExerciseUpgradesSliders || {};
  function boot(nsKey, nsSettings) {
            function productTeaserLayoutUpgrades () {
              let section = document.querySelector(`#shopify-section-${nsSettings.sectionId}`)
  
              let breakpoint = window.matchMedia('(min-width:700px)');
              let contentContainerEl = section.querySelector('.' + nsSettings.containerClass)
              let swiperWrapperEl = contentContainerEl.querySelector('[data-swiper-wrapper]')
              let swiperEl = contentContainerEl.querySelector('[data-swiper-container]')
              let swiperPaginationEl = contentContainerEl.querySelector('.swiper-pagination')
              let {
                layoutMobile,
                layoutDesktop,
                itemsPerRowDesktop,
                itemsPerRowMobile,
              } = contentContainerEl.dataset;
  
              let productTeaserSwiper;
            
              function waitForSwiper(callback) {
                if (typeof Swiper !== 'undefined') {
                  callback();
                } else {
                  const checkInterval = setInterval(() => {
                    if (typeof Swiper !== 'undefined') {
                      clearInterval(checkInterval);
                      callback();
                    }
                  }, 100);
                }
              }

              function initializeSwiper () {
                if (productTeaserSwiper) return;
                productTeaserSwiper = new Swiper(swiperEl , {
                  slidesPerView: 1.075,
                  spaceBetween: 8,
  
                  speed: 600,
  
                  breakpoints: {
                    320: {
                      slidesPerView: 1.075,
                      spaceBetween: 8
                    },
                    480: {
                      slidesPerView: 1.625,
                      spaceBetween: 8
                    },
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    800: {
                      slidesPerView: 2,
                      spaceBetween: 25
                    },
                    1024: {
                      slidesPerView: +itemsPerRowDesktop,
                      spaceBetween: 40
                    }
                  },
  
                  autoHeight: true,
  
                  navigation: {
                    nextEl: contentContainerEl.querySelector('.ns-exercise__swiper-button-next'),
                    prevEl: contentContainerEl.querySelector('.ns-exercise__swiper-button-prev'),
                  },
  
                  pagination: {
                    el: contentContainerEl.querySelector('.swiper-pagination'),
                    clickable: true
                  },
  
  
                  on: {
                    init: function () {
                      // this.updateAutoHeight();
                      // setTimeout(() => {
                      //   this.updateAutoHeight();
                      // }, 2000);
                      this.pagination.render();
                      this.pagination.init();
                      this.pagination.update();
                    },
                  }
  
                })            
              }
  
  
              function destroySwiper() {
                  if (typeof productTeaserSwiper !== 'undefined') {
                      productTeaserSwiper.destroy(true, true)
                  }
              }
              function breakpointChecker(breakpoint) {
                  if (breakpoint.matches === true) {
                    if (layoutDesktop == 'slider') {
                      swiperWrapperEl.style.display = 'flex'
                      swiperWrapperEl.classList.add('swiper-wrapper')
                      swiperPaginationEl.style.display = 'block'
                      waitForSwiper(() => {
                        initializeSwiper()
                      })
                      return
                    } else {
                      swiperWrapperEl.style.display = 'grid'
                      swiperWrapperEl.classList.remove('swiper-wrapper')
                      swiperPaginationEl.style.display = 'none'
                      destroySwiper();
                      return
                    }
                  } else if (breakpoint.matches === false) {
                    if (layoutMobile == 'slider') {
                      swiperWrapperEl.style.display = 'flex'
                      swiperWrapperEl.classList.add('swiper-wrapper')
                      swiperPaginationEl.style.display = 'block'
                      waitForSwiper(() => {
                        initializeSwiper()
                      })
                      return
                    } else {
                      swiperWrapperEl.classList.remove('swiper-wrapper')
                      swiperPaginationEl.style.display = 'none'
                      setTimeout(() => {
                        swiperWrapperEl.style.display = 'grid'
                      }, 0);
                      swiperWrapperEl.style.display = 'grid'
                      destroySwiper();
                      return
                    }
                  }
              };
  
  
              breakpointChecker(breakpoint);
              breakpoint.addEventListener("change", () => {
                  breakpointChecker(breakpoint)
              })
  
            }
  
            productTeaserLayoutUpgrades()
  
            if (Shopify.designMode) {
              document.addEventListener("shopify:section:load", () => {
                productTeaserLayoutUpgrades()
              });
            }
        
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
